import { render, staticRenderFns } from "./buttons-default.vue?vue&type=template&id=67f317d8&scoped=true"
import script from "./buttons-default.vue?vue&type=script&lang=js"
export * from "./buttons-default.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f317d8",
  null
  
)

export default component.exports